import React from 'react';

import { Checkbox, type CheckboxChangeEvent } from '../Checkbox/Checkbox';

import { type TableResourceRecord, type TableSelectionConfig } from './Table.types';

import styles from './Table.module.scss';

export interface TableSelectionAllControlProps<RecordType> {
    selection: TableSelectionConfig<RecordType>;
    dataSource: RecordType[];
}

const TableSelectionAllControl = <RecordType extends TableResourceRecord = any>({
    selection,
    dataSource
}: TableSelectionAllControlProps<RecordType>) => {
    const { selectedRowKeys, onChange } = selection;
    const isAllSelected = dataSource.every((row) => selectedRowKeys.includes(row.key));
    const isIndeterminate =
        !isAllSelected && dataSource.some((row) => selectedRowKeys.includes(row.key));

    const handleSelectAllRows = (e: CheckboxChangeEvent) => {
        const { checked } = e.target;
        const newSelectedRowKeys = checked
            ? dataSource.map((row) => row.key)
            : selectedRowKeys.filter((key) => !dataSource.some((row) => row.key === key));
        const selectedRows = dataSource.filter((row) => newSelectedRowKeys.includes(row.key));
        onChange(newSelectedRowKeys, selectedRows);
    };

    return (
        <div className={styles.tableSelectionControl}>
            <Checkbox
                checked={isAllSelected}
                indeterminate={isIndeterminate}
                onChange={handleSelectAllRows}
            />
        </div>
    );
};

export default TableSelectionAllControl;
